export enum EUrl {
	Attributes = 'attributes',
}
